export default {
  middleware_url: "https://esmal.fluid-it.fr",
  cake_url: "https://esmal.cake.fluid-it.fr",
  pwa_url: "https://app.esmal.fluid-it.fr",
  isWavesoftEnabled: false,
  isUrbantzEnabled: false,
  showLockBillingButton: true,
  useRatingSystem: true,
  useMapPage: true,
  useGpsTracking: true,
  instancePrefix: "13",
  googleMap: {
    api: "AIzaSyCRZWR7u9mGBTVXCctRWQZFO8F8YtUMZds",
  },
};
